export default __webpack_public_path__ + "static/media/logo.49dad6f3.png";